import gql from 'graphql-tag';

export const smartResultCard = gql`
  fragment SmartResultCard on SmartScheduleOutput {
    clientTimezone
    openingCards {
      timeSlots {
        timeSlot {
          startTime
          endTime
          adjacentType
        }
        clientFullyAvailable
        effectiveStartDate
        previousAdjacentEndDate
        trailingAdjacentEndDate
      }
      provider {
        id
        name
        displayName
        telehealthLinks
        weeklyBookedSessions
        weeklyTargetSessions
        clinic {
          id
          timezone
          abbreviation
        }
        speciality {
          id
          abbreviation
        }
      }
      appointmentType {
        id
        title
      }
      clinic {
        id
        name
        abbreviation
        timezone
      }
      endDate
      dayOfWeek
      isTelehealth
      isInClinic
      isOffsite
      allowedLocations
      maxBookableMinutes
    }
  }
`;
